import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LikesDto } from '@timechef/core/api';

@Component({
  selector: 'app-like-counter',
  templateUrl: './like-counter.component.html',
  styleUrls: ['./like-counter.component.scss'],
  standalone: false,
})
export class LikeCounterComponent {
  @Input() hideTotal = false;
  @Input() likes!: LikesDto;

  @Output() likeClick = new EventEmitter<boolean>();

  onClick() {
    const newState = !this.likes.isLikedByUser;
    // On met le coeur en rouge tout de suite, sinon il faut attendre la nouvelle valeur du Store, sauf qu'il y a une alert avant donc on verra le coeur non coché tant qu'on a pas validé l'alert
    if (newState) {
      setTimeout(() => {
        this.likes.isLikedByUser = true;
      }, 0);
    }

    this.likeClick.emit(newState);
  }
}
